var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive,
      width: "800"
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Create Filter ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              {
                staticClass: "pt-2"
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "py-0",
                    attrs: {
                      cols: "12",
                      sm: "8"
                    }
                  },
                  [
                    _c("gg-select", {
                      attrs: {
                        label: "Mailbox",
                        items: _vm.accountOptions,
                        loading: _vm.loading,
                        disabled: _vm.loading || _vm.saving
                      },
                      model: {
                        value: _vm.account,
                        callback: function callback($$v) {
                          _vm.account = $$v
                        },
                        expression: "account"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm.isActive && _vm.account
              ? _c("create-filter", {
                  key: _vm.account,
                  ref: "form",
                  attrs: {
                    account: _vm.account,
                    embedded: ""
                  },
                  on: {
                    saving: function saving($event) {
                      _vm.saving = $event
                    },
                    stored: _vm.stored
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.saving,
                  disabled: _vm.loading || !_vm.account
                },
                on: {
                  click: _vm.submit
                }
              },
              [_vm._v(" Create Filter ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }